import React from 'react';
import { View } from '@24i/nxg-sdk-quarks';
import { TrackProps } from './types';

const Track = ({ tintColor, width, style }: TrackProps) => (
    <View style={[style, { backgroundColor: tintColor, width }]} />
);
export default Track;
